import { render, staticRenderFns } from "./bulletinList.vue?vue&type=template&id=63bb9ffc&scoped=true&"
import script from "./bulletinList.vue?vue&type=script&lang=js&"
export * from "./bulletinList.vue?vue&type=script&lang=js&"
import style0 from "./bulletinList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bulletinList.vue?vue&type=style&index=1&id=63bb9ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb9ffc",
  null
  
)

export default component.exports